export const RevisionPaymentType = {
  SCHEDULED_PAYMENT: 1 as const,
  LICENSE_PAYMENT: 2 as const
}

export type RevisionPaymentTypeKey = keyof typeof RevisionPaymentType
//export type RevisionPaymentTypeValue = (typeof RevisionPaymentType)[RevisionPaymentTypeKey];
